import { render, staticRenderFns } from "./PremiumViewComponent.vue?vue&type=template&id=bef7e32c&scoped=true"
import script from "./PremiumViewComponent.vue?vue&type=script&lang=js"
export * from "./PremiumViewComponent.vue?vue&type=script&lang=js"
import style0 from "./PremiumViewComponent.vue?vue&type=style&index=0&id=bef7e32c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef7e32c",
  null
  
)

export default component.exports